import Swiper from 'swiper';
import 'swiper/swiper-bundle.css';

export default class ProductItem extends HTMLElement {
  constructor() {
    super();
    this.carouselEl = this.querySelector('.swiper');
    this.currentSlideText = this.querySelector('.current-slide');
    this.isSwipeable = this.dataset?.swipeable === 'true';
    this.showMobileSimple = this.dataset?.mobileSimple === 'true';
    this.isLargeQuery = window.matchMedia('(min-width: 1024px)').matches;
  }

  connectedCallback() {
    // if show mobile simple is true, and we are on a small screen, do not initialize the carousel
    if (this.showMobileSimple && !this.isLargeQuery) {
      return;
    }

    // init carousel
    if (this.carouselEl) {
      this.carousel = new Swiper(this.carouselEl, {
        loop: true,
        slidesPerView: 1,
        spaceBetween: 0,
        allowTouchMove: this.isSwipeable,
      });
      this.carousel.on('slideChange', () => {
        if (this.currentSlideText && this.carousel) {
          this.currentSlideText.innerHTML = this.carousel.realIndex + 1;
        }
      });
      this.prev = this.querySelector('.prev');
      this.next = this.querySelector('.next');
      if (this.prev) {
        this.prev.addEventListener('click', () => {
          this.carousel.slidePrev();
        });
      }
      if (this.next) {
        this.next.addEventListener('click', () => {
          this.carousel.slideNext();
        });
      }
    }
  }
}
